import { MiniCompletedRow } from './MiniCompletedRow'
import { hint } from '../../lib/words'

type Props = {
  guesses: string[]
}

export const MiniGrid = ({ guesses }: Props) => {
  return (
    <div className="pb-6">
      {guesses.map((guess, i) => (
        <MiniCompletedRow key={i} guess={guess} hint={ i===0 && hint!=='' ? hint : '' } />
      ))}
    </div>
  )
}
